import { HStack } from '@bpba/ui-components';
import { FaInfoCircle } from 'react-icons/fa';
import styled from 'styled-components';
import { margin, MarginProps } from 'styled-system';

type Props = {
  size: number;
} & MarginProps;

export const InfoIcon = ({ size, ...otherProps }: Props) => {
  return (
    <HStack minWidth={size} maxWidth={size} minHeight={size} maxHeight={size} aria-hidden="true" {...otherProps}>
      <StyledInfoCircle />
    </HStack>
  );
};

const StyledInfoCircle = styled(FaInfoCircle)<MarginProps>(margin, {
  height: '100%',
  width: '100%',
});
